export enum SubscriptionType {
  Club = 'Club',
  Team = 'Team',
  League = 'League'
}
